import { api } from "../../services/Api.js";
import { modalService } from '../../services/ModalService.js';
import i18n from '../../language.js';
//https://www.html5rocks.com/en/tutorials/file/filesystem/
export function get_crossdomain_download({ state }, payload ){

    var loader=modalService.createLoader(i18n.t("language.downloading_content")); 

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    payload.token=state.appSettings.token
    
    return api
    .post(school,"get_crossdomain_download.php",payload)
    .then( result =>{ 
      
      setTimeout(()=>{
        loader.close();
      },1000);
      
      return result;// maike chainable
    })
 
 }


 

